import {provideHttpClient}                                        from '@angular/common/http';
import {ApplicationConfig, isDevMode, provideZoneChangeDetection} from '@angular/core';
import {FirebaseOptions, initializeApp, provideFirebaseApp}       from '@angular/fire/app';
import {connectAuthEmulator, getAuth, provideAuth}                from '@angular/fire/auth';
import {connectFirestoreEmulator, getFirestore, provideFirestore} from '@angular/fire/firestore';
import {connectFunctionsEmulator, getFunctions, provideFunctions} from '@angular/fire/functions';
import {getStorage, provideStorage}                               from '@angular/fire/storage';
import {provideRouter}                                            from '@angular/router';
import {provideServiceWorker}                                     from '@angular/service-worker';

import {routes} from './app.routes';


// vape config
const firebaseApp: FirebaseOptions = {
	projectId        : "logr-pwa-2024",
	appId            : "1:955366219879:web:6b7a1e69dc3f17006c74c2",
	storageBucket    : "logr-pwa-2024.appspot.com",
	apiKey           : "AIzaSyAeDa1z3dcVER4XTKPlr8L49Pk6dPMDg58",
	authDomain       : "logr-pwa-2024.firebaseapp.com",
	messagingSenderId: "955366219879"
}

const useEmulators = {
	auth     : false,
	firestore: false,
	functions: true
};
export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({eventCoalescing: true}),
		provideRouter(routes),
		provideHttpClient(),

		provideFirebaseApp(() => initializeApp({
												   projectId    : "logr-pwa-2024",
												   appId        : "1:955366219879:web:6b7a1e69dc3f17006c74c2",
												   storageBucket: "logr-pwa-2024.appspot.com",
												   apiKey       : "AIzaSyAeDa1z3dcVER4XTKPlr8L49Pk6dPMDg58",
												   authDomain   : "logr-pwa-2024.firebaseapp.com",
												   messagingSenderId: "955366219879"
											   })),

		provideAuth(() => {
			const auth = getAuth();
			if (isDevMode() && useEmulators.auth) {
				connectAuthEmulator(auth, 'http://localhost:9099');
			}
			return auth;
		}),

		provideFirestore(() => {
			const firestore = getFirestore();
			if (isDevMode() && useEmulators.firestore) {
				connectFirestoreEmulator(firestore, 'localhost', 8080);
			}
			return firestore;
		}),

		provideFunctions(() => {
			const functions = getFunctions();
			if (isDevMode() && useEmulators.functions) {
				connectFunctionsEmulator(functions, 'localhost', 5001);
			}
			return functions;
		}),

		provideStorage(() => getStorage()),

		provideServiceWorker('ngsw-worker.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerWhenStable:30000'
		}),
	]
};
